/**
 * Düzeltme satırı etiketleri:
 * - income  → kalem "alındı" (elden alınan / bütçeye giren)
 * - expense → kalem "kullanıldı" (harcanan / bütçeden çıkan)
 */
export function formatSettlementEntryLabel(entry, translate) {
  const t = translate || ((k, opts) => opts?._ || k);
  const name = (entry?.categoryName || entry?.categoryCode || '').trim();
  const note = (entry?.note || '').trim();
  const verb = entry?.type === 'expense'
    ? t('report.used', { _: 'kullanıldı' })
    : t('report.received', { _: 'alındı' });
  const main = name
    ? `${name} ${verb}`
    : entry?.type === 'expense'
      ? t('report.expense_used', { _: 'Gider kullanıldı' })
      : t('report.income_received', { _: 'Gelir alındı' });
  return note ? `${main} — ${note}` : main;
}

export function formatSettlementEntryType(entry, translate) {
  const t = translate || ((k, opts) => opts?._ || k);
  return entry?.type === 'expense'
    ? t('report.expense', { _: 'Expense' })
    : t('report.income', { _: 'Income' });
}
